import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { createContext, useState, useEffect, useContext } from 'react';
var ProgressContext = /*#__PURE__*/createContext({});
export var ProgressProvider = function ProgressProvider(_ref) {
  var children = _ref.children;

  var _useState = useState({
    index: 0,
    complete: false,
    show: false,
    value: 0,
    max: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      progressState = _useState2[0],
      setProgressState = _useState2[1];

  return /*#__PURE__*/React.createElement(ProgressContext.Provider, {
    value: {
      progressState: progressState,
      setProgressState: setProgressState
    }
  }, children);
};
export var useProgress = function useProgress(initialProgressState) {
  var _useContext = useContext(ProgressContext),
      progressState = _useContext.progressState,
      setProgressState = _useContext.setProgressState;

  useEffect(function () {
    if (initialProgressState) {
      setProgressState(initialProgressState);
    }
  }, []);
  return {
    progressState: progressState,
    setProgressState: setProgressState
  };
};